module.exports = __webpack_public_path__ + "img/button.a9bd7253.png";